import React from 'react';
/**
 * Vertical spacer and a drop target. Calculates spacing to use depending on the first and last flags.
 * Can optionally display a placeholder element to indicate the drop area.
 *
 * @param {object} props - The component props.
 * @param {string} props.editorPath - Value for the `data-editor-path` attribute, used for identifying the element in the editor.
 * @param {React.ReactNode} [props.placeholderElement] - Optional element shown to indicate the drop target area to the user.
 * @param {number} props.spacing - The spacing (in pixels) between components. Should be an even number so the drop target is centered.
 * @param {boolean} props.first - Whether this spacer is the first in the list. Affects padding calculation.
 * @param {boolean} props.last - Whether this spacer is the last in the list. Affects padding calculation.
 * @returns {JSX.Element} The rendered spacer/drop target element.
 */
export const DropTargetSpacerHorizontal = (props) => {
    let rootPaddingTop = props.spacing / 2;
    let rootPaddingBottom = props.spacing / 2;
    let containerPaddingTop = props.spacing / 2;
    let containerPaddingBottom = props.spacing / 2;
    let placeholderPaddingTop = props.spacing / 2;
    let placeholderPaddingBottom = props.spacing / 2;
    if (props.first && props.last) {
        rootPaddingTop = 0;
        rootPaddingBottom = 0;
        containerPaddingTop = 0;
        containerPaddingBottom = 0;
        placeholderPaddingTop = 0;
        placeholderPaddingBottom = 0;
    }
    else if (props.first) {
        rootPaddingTop = 0;
        rootPaddingBottom = 0;
        containerPaddingTop = 0;
        containerPaddingBottom = props.spacing;
        placeholderPaddingTop = 0;
        placeholderPaddingBottom = props.spacing;
    }
    else if (props.last) {
        rootPaddingTop = 0;
        rootPaddingBottom = 0;
        containerPaddingTop = props.spacing;
        containerPaddingBottom = 0;
        placeholderPaddingTop = props.spacing;
        placeholderPaddingBottom = 0;
    }
    return (React.createElement("div", { "data-drag-target": true, "data-editor-path": props.editorPath, style: { paddingTop: rootPaddingTop, paddingBottom: rootPaddingBottom } },
        React.createElement("div", { "data-drag-target-container": true, style: { display: 'none', paddingTop: containerPaddingTop, paddingBottom: containerPaddingBottom } }),
        props.placeholderElement != null && (React.createElement("div", { "data-drag-target-placeholder": true, style: { display: 'block', paddingTop: placeholderPaddingTop, paddingBottom: placeholderPaddingBottom } }, props.placeholderElement))));
};
